export default "__VITE_ASSET__BESrh045__"